import { useEffect, useState } from 'react';
import { getProduto } from 'config/produto-env';
import { useAuth } from 'context/AuthContext';
import { useActivePhases } from 'hooks/useControlDate';
import { buscarIniciativasDoUsuario } from 'services/pre-inscricao.service';
import { getSituacaoPreInscricao, isPreInscricaoAberta, SituacaoPreInscricao } from 'utils/destino-inicial';

/**
 * Situação do usuário logado na pré-inscrição aberta (`null` fora dela).
 * Usado pela home para escolher a notificação da pré-inscrição.
 */
export function useSituacaoPreInscricao(): SituacaoPreInscricao | null {
  const { user } = useAuth();
  const fases = useActivePhases();
  const [situacao, setSituacao] = useState<SituacaoPreInscricao | null>(null);

  const produto = getProduto();
  const pessoa = user?.pessoa;
  const aberta = isPreInscricaoAberta(fases, produto);

  useEffect(() => {
    let ativo = true;

    if (!pessoa || !aberta) {
      setSituacao(null);
      return;
    }

    buscarIniciativasDoUsuario().then((iniciativas) => {
      if (ativo) setSituacao(getSituacaoPreInscricao({ pessoa, fases, produto, iniciativas }));
    });

    return () => {
      ativo = false;
    };
  }, [pessoa, fases, produto, aberta]);

  return situacao;
}
